import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-47" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-48" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-49" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-50" data-mp="57ebob4uv5ec">
            La Différence ANGLAIS PRÊT™
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-51" data-mp="3rgyqf27gwebt">
            D&apos;un enseignant épuisé à un{' '}
            <span className="italic text-brand" data-id="element-52" data-mp="3dj0o4v6f88co">guide confiant.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-53" data-mp="3ig0sn1nmh31o">
            Donnez à vos cours un rythme clair, à vos élèves plus de confiance
            linguistique et à vous-même le temps de reprendre plaisir à
            enseigner.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-54" data-mp="1j9cbegnjy0yo">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-55" data-mp="1t071jw3x5kpe" data-mpi={index}>
              <dt className="sr-only" data-id="element-56" data-mp="wb7rqcnosav3">{stat.label}</dt>
              <dd data-id="element-57" data-mp="wciy8k8inwpw">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-58" data-mp="1aah8bdft16zl">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-59" data-mp="15acpvhvc626q">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-60" data-mp="2gq1c270rmx6h">
          <div className="grid md:grid-cols-2" data-id="element-61" data-mp="2oq7fv4b318qg">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-62" data-mp="2otljefvhfnzh">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-63" data-mp="2srj9dkx2ue3x">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-64" data-mp="2xq43r3pne3kg" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-65" data-mp="32onurij3m5jo">
                Avant Anglais Prêt
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-66" data-mp="2a3e8cl7t178t">
                Le coût de l&apos;improvisation
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-67" data-mp="2jsfpieq35uod">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-68" data-mp="1mdjuc0br1cmz">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-69" data-mp="1js2gdb33ji6v" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-70" data-mp="19w94ltx7bsq5">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-71" data-mp="14u1msnpoxifw">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-72" data-mp="10vknurgfbe9k" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-73" data-mp="w1gdrzbv2q49">
                Avec Anglais Prêt
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-74" data-mp="m53ln5vyskbm">
                Le système ANGLAIS PRÊT™
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-75" data-mp="d45fagy200pv">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-76" data-mp="11utcs86gn5jl">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-77" data-mp="t2hlyl7fpg33" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-78" data-mp="j6emxo7vpxkd">
            Un système complet pour préparer moins et enseigner avec plus de
            sens, du CP à la Terminale.
          </p>
        </div>
      </div>
    </section>;
}